// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PlayerScore_wrapper__2b4DZ","scoreValue":"PlayerScore_scoreValue__d0QE7","playerNameText":"PlayerScore_playerNameText__16AFW"};